export enum UpsellExclusions {
  MIELE = 'Miele',
  MULTIPLAN = '',
  BANK = 'Banks',
  RP_GOLD = 'R&P Gold',
  SKY_SINGLE = 'Sky',
  SKY_MULTIPLAN = 'Sky',
  JOHN_LEWIS = 'John Lewis',
  SCOTTISH_POWER = 'Scottish Power',
  UPSELL_DISABLED = 'toggle',
}

export enum PlanType {
  SINGLE = 'Single',
  MULTIPLAN = 'Multiplan',
}
